export default __webpack_public_path__ + "static/media/complementary--caravan-trailers--g2.a2b733be.png";